/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */

import Button from "components/Button";
import Form from "components/Form";
import Label from "components/Label";

import React, { useState } from "react";
import { useRouter } from "next/router";

import segment from "lib/segment";
import styles from "./styles.module.scss";
import { Place } from "utils/form";

interface FormValues {
  firstname: string;
  lastname: string;
  phone: string;
  place: Place;
  email: string;
}

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface LocationInput {
  address_components: AddressComponent[];
}

function getPostalCode(
  location: LocationInput | undefined
): string | undefined {
  const postalCodeComponent = location?.address_components.find((component) =>
    component.types.includes("postal_code")
  );

  return postalCodeComponent?.long_name;
}

const UserInfo = ({ userInfo }: { userInfo: FormValues | undefined }) => {
  const [waitlistSubmitted, setWaitlistSubmitted] = useState(false);

  const { query } = useRouter();

  const zipcode = getPostalCode(userInfo?.place);

  const formattedUserInfo = { ...userInfo, zip: zipcode };

  const submitToWaitlist = ({
    zip,
    email,
    firstname,
    lastname
  }: {
    zip: string;
    email: string;
    firstname: string;
    lastname: string;
  }) => {
    segment.track("Add to Waitlist", {
      ...query,
      zip,
      email,
      firstname,
      lastname
    });
    setWaitlistSubmitted(true);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.rightPanel}>
          <div className={styles.formTile}>
            {waitlistSubmitted ? (
              <>
                <Label
                  className={styles.formTitle}
                  variant="h6-centered"
                  color="primary2"
                >
                  Thanks for joining our waitlist!
                </Label>
                <div className={styles.waitlistDescription}>
                  Stay tuned for updates.
                </div>
              </>
            ) : (
              <>
                <Label
                  className={styles.formTitle}
                  variant="h6-centered"
                  color="primary2"
                >
                  We&apos;re launching in your neighborhood soon!
                </Label>
                <div className={styles.waitlistDescription}>
                  Join our waitlist to receive updates.
                </div>
                <div className={styles.form}>
                  <Form
                    initialValues={formattedUserInfo}
                    id="lead_flow_waitlist"
                    onSubmit={submitToWaitlist}
                    fields={[
                      {
                        type: "text",
                        id: "firstname",
                        placeholder: "First name"
                      },
                      {
                        type: "text",
                        id: "lastname",
                        placeholder: "Last name"
                      },
                      {
                        type: "text",
                        id: "email",
                        props: { required: true, type: "email" },
                        placeholder: "Email address"
                      },
                      {
                        type: "text",
                        id: "zip",
                        props: { required: true },
                        placeholder: "Zip code"
                      }
                    ]}
                  >
                    {({ invalid }) => (
                      <div className={styles.formFooter}>
                        <Button
                          type="submit"
                          className={styles.submit}
                          variant="accent"
                        >
                          Join Waitlist
                        </Button>
                      </div>
                    )}
                  </Form>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
